import { render, staticRenderFns } from "./DeauthNotificationRecipientsBlock.vue?vue&type=template&id=403ab654&scoped=true"
import script from "./DeauthNotificationRecipientsBlock.vue?vue&type=script&lang=js"
export * from "./DeauthNotificationRecipientsBlock.vue?vue&type=script&lang=js"
import style0 from "./DeauthNotificationRecipientsBlock.vue?vue&type=style&index=0&id=403ab654&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403ab654",
  null
  
)

export default component.exports